// this file will contain the theme and be imported into all other files that contain the grommet component that will use the theme

const theme = {
  name: "1st iteration the",
  meter: { color: "black" },
  table: {
    body: {
      align: "start",
      pad: {
        horizontal: "small",
        vertical: "small"
      },
      align: "start",
      border: "top"
    }
  },
  rounding: 4,
  spacing: 24,
  defaultMode: "light",
  select: { backround: "white" },
  button: {
    border: { radius: "4px" },
    padding: { vertical: "4px", horizontal: "22px" }
  },
  global: {
    // the breakpoint number to start treating the window as small
    //breakpoints: { small: 768 },
    control: {
      border: {
        radius: "4px",
        color: "brand"
      },
      animation: {
        duration: "10s",
        jiggle: { duration: "0.1s" }
      }
    },
    hover: { dark: "white", light: "black" },
    colors: {
      // color of a placeholder in text input
      //placeholder: "#051932",
      brand: "#051932",
      background: {
        dark: "#222222",
        light: "#FFFFFF"
      },
      "background-strong": {
        dark: "#000000",
        light: "#FFFFFF"
      },
      "background-weak": {
        dark: "#444444a0",
        light: "#E8E8E880"
      },
      "background-xweak": {
        dark: "#66666699",
        light: "#CCCCCC90"
      },
      text: {
        dark: "#EEEEEE",
        light: "#333333"
      },
      "text-strong": {
        dark: "#FFFFFF",
        light: "#000000"
      },
      "text-weak": {
        dark: "#CCCCCC",
        light: "#444444"
      },
      "text-xweak": {
        dark: "#999999",
        light: "#666666"
      },
      border: "background-xweak",
      control: "brand",
      "active-background": "background-weak",
      "active-text": "text-strong",
      "selected-background": "background-strong",
      "selected-text": "text-strong",
      "status-critical": "#FF4040",
      "status-warning": "#FFAA15",
      "status-ok": "#00C781",
      "status-unknown": "#CCCCCC",
      "status-disabled": "#CCCCCC",
      focus: "#2DB0FE"
    },
    font: {
      family: "Helvetica"
    },
    graph: {
      colors: {
        dark: ["brand"],
        light: ["brand"]
      },
      checkBox: {
        color: {
          dark: "#051932",
          light: "#051932"
        }
      }
    }
  }
};

export default theme;
